import React, {Fragment, useRef, useState} from 'react';
import { Popover, Card, Text, Select, List, Accordion, Explanation_text } from './';
import { Form, Field } from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';
import arrayMutators from 'final-form-arrays';
import ViewColumnIcon from '@material-ui/icons/ViewColumn';
import AddIcon from '@material-ui/icons/Add';
import PeopleIcon from '@material-ui/icons/PeopleAlt';
import BusinessIcon from '@material-ui/icons/Business';
import AssignmentIcon from '@material-ui/icons/Assignment';
import FilterNoneIcon from '@material-ui/icons/FilterNone';
import IconButton from '@material-ui/core/IconButton';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Avatar from '@material-ui/core/Avatar';
import {connect} from 'react-redux';

function ColumnOrder(props){
    const[save_filter,setSaveFilter]=useState(false);
    let initial_values = useRef({column_sections:setCheckedColumns({
            company: { name: 'Company columns', colour: 'green', columns: getColumnsArray(props.ftc.main_company_columns) },
            contact: { name: 'Contact columns', colour: 'purple', columns: getColumnsArray(props.ftc.contact_first_block_columns) },
            deal: { name: 'Deal columns', colour: 'red', columns: getColumnsArray(props.ftc.deal_columns) },
        }, ["contact_last_name", "contact_first_name"])});

    function onSubmit(params){
        let columns = []; for (let c of getCheckedColumns(params.column_sections)){columns.push(c.id);}
        let send={id:params.id, name:params.name, description:params.description, columns:JSON.stringify(columns)};
        if(send.id!=undefined){props.updateTableColumnOrder(send);}
        else{props.createTableColumnOrder(send);}
    }
   
    return (<Fragment><Popover trigger={(props.without_icon_button == true) ? <ViewColumnIcon/> : <IconButton ><ViewColumnIcon/></IconButton>} content={
        <div style={{ height: '90vh', maxHeight: '900px', width: '90vw', maxWidth:'900px', padding: '20px', paddingLeft: '10px' }}>
            <Form
                onSubmit={onSubmit}
                initialValues={initial_values.current}
                mutators={{ ...arrayMutators }}
            >
                {form_props => (
                    <div style={{ position: 'relative',height:'100%' }}>
                        <form style={{ height: '100%', marginTop: '-15px', position: 'relative' }} onSubmit={form_props.handleSubmit}>
                        {(save_filter==true)?
                            <Fragment>
                                    <Typography style={{ textAlign: 'center', marginTop: '20px', marginBottom: '20px' }} color='primary'>Save filter</Typography>
                                    <Typography style={{ marginLeft: '20px' }}><Explanation_text text='column_order_permanent_save_confirm' /></Typography>
                                    <div style={{ marginTop: '20px'}}>
                                        <div><Text title='Name' name='name' required /></div>
                                        <div><Text title="Description" name="description" multiline rows={3}/></div>
                                    </div>
                            </Fragment>
                            :
                            <ColumnOrderAndSelection {...props}/>
                        }
                        <div style={{position:'absolute', bottom:'0px', paddingTop: '10px', marginBottom: '0px', width: '100%', boxShadow: "0px -10px 8px -10px #888888" }}>
                            <div style={{ width: '100%', position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                <Button style={{marginLeft:'10px', marginRight:'10px'}} variant='contained' onClick={() => {if(save_filter==true){setSaveFilter(false);}else{form_props.form.reset(); setBlockInitial(true); onSubmit({}); }}}>{(save_filter==true)?"Back":"Reset"}</Button>
                                <Button style={{marginLeft:'10px', marginRight:'10px'}} color='primary' variant='contained' onClick={()=>{if(save_filter==false){setSaveFilter(true);}else{setSaveFilter(false); form_props.form.submit();}}}>Save</Button>
                                <Button style={{marginLeft:'10px', marginRight:'10px'}} color='secondary' variant='contained' onClick={()=>{form_props.form.submit();}}>Set</Button>
                           </div>
                        </div>
                        </form> 
                    </div> 
                )} 
            </Form>
        </div>
} /></Fragment>);
}

function getOrderIndex(columns, col_key){
    let order=0;
    for(let x of columns){
        if(col_key==x){return order;}
        order+=1;
    }
}

function setCheckedColumns(column_sections, columns){
    for (let cs_key in column_sections) {
        for (let col_key in column_sections[cs_key].columns) {
            if(columns.includes(col_key)){
                column_sections[cs_key].columns[col_key].order=getOrderIndex(columns, col_key);
                column_sections[cs_key].columns[col_key].checked=true;
            }
        }
    }
    return column_sections;
}


function getCheckedColumns(column_sections) {
    let columns = [];
    for (let cs_key in column_sections) {
        let cs = column_sections[cs_key];
        for (let col_key in cs.columns) {
            let col = cs.columns[col_key];
            if (col.checked == true) {
                col.colour = cs.colour;
                columns.push(col);
            }
        }
    }
    columns.sort((a, b) => a.order - b.order);
    return columns;
}

function ColumnOrderIndex(props){

    
    return(
        <Form
            onSubmit={() => { }}
            initialValues={{ }}
        >
            {form_props => (
                <div style={{ position: 'relative' }}>
                    <form style={{ height: 'calc(100% - 10px)', marginTop: '-15px', position: 'relative' }} onSubmit={form_props.handleSubmit}>
                    <Typography color='primary' style={{marginTop:'10px', marginBottom:'10px', marginLeft:'10px'}}>Select default column group per entity</Typography>
                    <Grid container>
                        <Grid item xs={12} md={6} style={{marginBottom:'10px'}}><Select size='small' name='company_column_id' title="Companies" select_data={[]}/></Grid>
                        <Grid item xs={12} md={6} style={{marginBottom:'10px'}}><Select size='small' name='contact_column_id' title="Contacts" select_data={[]}/></Grid>
                        <Grid item xs={12} md={6} style={{marginBottom:'10px'}}><Select size='small' name='deal_column_id' title="Deals" select_data={[]}/></Grid>
                        <Grid item xs={12} md={6} style={{marginBottom:'10px'}}><Select size='small' name='timeline_item_column_id' title="Timeline items" select_data={[]}/></Grid>
                    </Grid>
                    <hr/>
                    <List edit_on delete_on onEdit={(x)=>{props.setColumnSelection(x);}} onDelete={(x)=>{}} list_data={[{main_text:'TEST', secondary_text:'Descrption here', icon:<ViewColumnIcon/>, edit:true, delete:true}]}/>
                    </form>
                </div>
            )}
        </Form>
    )
}



function getColumnsArray(columns){let array={};
    for(let col of columns){array[col.id]=col;}
    return array;
}


function ColumnOrderAndSelection(props){
    let column_fields=useRef();
    const[new_column_index, setNewColumnIndex]=useState(0);

    let columns = useRef([
        ...props.ftc.main_company_columns,
        ...props.ftc.contact_first_block_columns,
       // ...props.ftc.getSpecialServicesColumns(entity, special_service, special_service_provider),
        ...props.ftc.contact_second_block_columns,
        ...props.ftc.deal_columns,
        ...props.ftc.contact_last_block_columns,
        ...props.ftc.getCustomFieldsColumns(props.workspace, 'CONTACT'),
        ...props.ftc.getCustomFieldsDecisionsColumns(props.workspace, props),
        ...props.ftc.company_columns,
        //...getStringListenerHeaders(props.workspace),
        ...props.ftc.prospect_status_columns,
        ...(props.workspace !== undefined && props.workspace.show_sensitive === true ? props.ftc.sensitive_prospect_columns : [])
    ]);

    

    console.log(columns, 'COLUMNSll');

    function moveCard(dragIndex, hoverIndex) {
        let new_column_fields={}
        for (let cs_key in column_fields.current.input.value) {
            let cs = column_fields.current.input.value[cs_key];
            let new_columns={};
            for (let col_key in cs.columns) {
                let col = cs.columns[col_key];
                let is_dragged=false; 
                if (col.order == dragIndex) {is_dragged=true;}
                if(dragIndex<hoverIndex){
                    if(col.order<=hoverIndex && col.order>dragIndex){col.order-=1;}  
                }else if(hoverIndex<dragIndex){
                    if(col.order>=hoverIndex && col.order<dragIndex){col.order+=1;}
                }
                if(is_dragged==true){col.order=hoverIndex;}
                new_columns[col_key]=col;
            }
            cs.columns=new_columns;
            new_column_fields[cs_key]=cs;
        }
       column_fields.current.input.onChange(JSON.parse(JSON.stringify(new_column_fields)));
    }

    return(
            <div style={{position:'relative', height:'calc(100% - 50px)', overflowY:'scroll'}}>
                            <Field name='column_sections'>{(f)=>{column_fields.current=f; return(null);}}</Field>
                            <Field name='column_sections'>{(field) =>{
                                let columns=getCheckedColumns(field.input.value);
                                let new_columns = []; let i = 0; for (let c of columns) { c.order = i; new_columns.push(c); i += 1;} columns=new_columns;
                            setNewColumnIndex(i);
                                return(
                                <Fragment>
                                    <Typography color='primary' style={{ marginLeft: '20px', marginTop: '15px', marginBottom: '15px' }}><span><ViewColumnIcon color='primary' style={{ position: 'absolute', left: '20px' }} /></span><span style={{ marginLeft: '40px' }}>Column selection</span></Typography>
                                        <Grid container style={{ width:'calc(100% - 50px)' , marginLeft:'25px', minHeight:'150px', maxHeight:'300px', overflowY:'scroll', borderWidth:'1px', borderStyle:'solid', borderColor:'black', borderRadius:'5px'}}>
                                        {columns.map((x, index) => {
                                        return (<Grid item xs={6} sm={4} md={3} style={{padding:'10px', cursor:'pointer'}}><Card
                                                key={x.id}
                                                index={index}
                                                id={x.id}
                                                onDrop={moveCard}
                                                text={
                                                    <Box display="flex" alignItems="center"><Avatar color="primary" style={{
                                                        width: 20, // Adjusted width for a more square-like shape
                                                        height: 20, // Same as width for the square
                                                        fontSize: '12px', // Font size
                                                        backgroundColor: 'white',
                                                        color: x.colour,
                                                        border: `2px solid ${x.colour}`, // Border with the same color
                                                        borderRadius: '8px', // Rounded corners
                                                        display: 'flex', // Ensures proper alignment of text inside
                                                        alignItems: 'center', // Centers text vertically
                                                        justifyContent: 'center', // Centers text horizontally
                                                        }}><Typography style={{fontSize:'9px'}}>{index+1}</Typography></Avatar><Typography variant="caption" style={{marginLeft:'10px', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis'}}>{x.label}</Typography></Box>
                                                } /></Grid>)
                                    })}
                                    </Grid>
                                </Fragment>
                             )}}</Field>
                            <Field name='column_sections'>{(field) =>{

                                console.log(field, Object.keys(field.input.value).length, 'ATTENTION');

                                return( 
                            <Grid container style={{ width: 'calc(100% - 30px)', marginLeft: '15px' }}>
                            {Object.keys(field.input.value).map(function(key, index){
                                console.log('ATTENTION', key);
                                let name="column_sections["+key+"]"
                                let column_selection = field.input.value[key];
                            
                                let checked_columns_amount=0;
                                for(let ccc_key in column_selection.columns){
                                    let ccc=column_selection.columns[ccc_key];
                                    if(ccc.checked==true){checked_columns_amount+=1;}
                                }
                                console.log('column section', column_selection, name, name+'[columns]');
                                return(<Grid item xs={6} sm={4}>
                                    <div style={{width:'calc(100% - 20px)', marginLeft:'10px', marginTop:'10px'}}>
                                    <Accordion content={[
                                        {
                                            title: <Box display="flex" alignItems="center"><Avatar color="primary" style={{
                                                width: 40, // Adjusted width for a more square-like shape
                                                height: 20, // Same as width for the square
                                                marginRight:'10px',
                                                fontSize: '12px', // Font size
                                                backgroundColor:'white',
                                                color:column_selection.colour,
                                                border: `2px solid ${column_selection.colour}`, // Border with the same color
                                                borderRadius: '8px', // Rounded corners
                                                display: 'flex', // Ensures proper alignment of text inside
                                                alignItems: 'center', // Centers text vertically
                                                justifyContent: 'center', // Centers text horizontally
                                            }}>{'('+checked_columns_amount+'/'+Object.keys(column_selection.columns).length+')'}</Avatar><Typography>{column_selection.name}</Typography></Box>, content:<div>
                                                <Field name={name+'[columns]'}>{(spec_fields) =>{
                                                    return(<div>  
                                                        {Object.keys(spec_fields.input.value).map(function (spec_key, spec_index) {
                                                            let spec_name=name+'[columns]['+spec_key+']';
                                                            let col=spec_fields.input.value[spec_key];
                                                            console.log(spec_name, col, 'testing_123');
                                                            return (<Field name={spec_name+"[order]"}>{(f_order)=><Field name={spec_name+"[checked]"}>{(f)=>{return(<div><FormControlLabel control={<Checkbox checked={f.input.value} style={{color:column_selection.colour}} onChange={(e)=>{f_order.input.onChange(new_column_index); setNewColumnIndex(new_column_index+1); f.input.onChange(e.target.checked);}} />} label={col.label} /></div>)}}</Field>}</Field>)
                                                        })}
                                                    </div>)}}</Field>
                                    </div>}]}/>
                                    </div>
                            </Grid>)
                            })}
                            </Grid>)}}
                            </Field>
            </div>
    )
}







export default connect(ss,dd)(ColumnOrder);

function ss(state){
    return {
        ftc:state.account.frontend_table_columns,
    }
}

function dd(dispatch){
    return {
        createTableColumnOrder:(val)=>{dispatch({type:'REQUEST_CREATE_TABLE_COLUMN_ORDER', payload:val});},
        updateTableColumnOrder:(val)=>{dispatch({type:'REQUEST_UPDATE_TABLE_COLUMN_ORDER', id:val.id, payload:val})}
    }
}